<template>
  <div class="writeTemplate-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span>笔记背景图类型：</span>
        <el-tag
          size="medium"
          :class="{ 'active-button-style': currentEffect === 'cloud' }"
          @click="selectTag('cloud')"
          >云端</el-tag
        >
        <el-tag
          size="medium"
          :class="{ 'active-button-style': currentEffect === 'handwrite' }"
          @click="selectTag('handwrite')"
          >手写模板</el-tag
        >
        <el-tag
          size="medium"
          :class="{ 'active-button-style': currentEffect === 'text' }"
          @click="selectTag('text')"
          >文本模板</el-tag
        >
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="
            $router.push({
              name: 'writeTemplateCreate',
              query: { usage: listParams.usage }
            })
          "
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t('commonMsg.new') }}
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="list-container" v-bar>
        <div class="writeTemplate-handle">
          <div
            v-for="(item, idx) in writeTemplate"
            :key="idx"
            class="writeTemplate-item"
          >
            <div class="writeTemplate-cover">
              <img class="writeTemplate-img" :src="item.file.url" alt="" />
            </div>
            <div class="writeTemplate-info">
              <p class="writeTemplate-info-title omitText" :title="item.title">
                标题：{{ item.title }}
              </p>
              <!-- <p
                style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
              >
                编号：{{ item.number }}
              </p> -->
              <!-- <p
                style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
              >
                类型：
                <span v-if="item.usage === 'handwrite'">手写模板</span>
                <span v-if="item.usage === 'text'">文本模板</span>
              </p> -->
              <p
                style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
              >
                分类：
                <span v-if="item.category">{{
                  item.category | filterWriteTemplateCategory
                }}</span>
                <span v-else>暂无</span>
              </p>
              <!-- <p
                style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                :title="item.model.join('\\')"
                v-if="
                  !(
                    item.model.length === 0 ||
                    (item.model.length === 1 && item.model[0] === '')
                  )
                "
              >
                型号：{{ item.model.join('\\') }}
              </p>
              <p
                v-if="
                  item.model.length === 0 ||
                    (item.model.length === 1 && item.model[0] === '')
                "
              >
                型号：暂无
              </p> -->

              <!-- <p
                style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                :title="item.lang.join('\\')"
                v-if="
                  !(
                    item.lang.length === 0 ||
                    (item.lang.length === 1 && item.lang[0] === '')
                  )
                "
              >
                语言：{{ item.lang.join('\\') }}
              </p>
              <p
                v-if="
                  item.lang.length === 0 ||
                    (item.lang.length === 1 && item.lang[0] === '')
                "
              >
                语言：暂无
              </p> -->

              <p
                style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
              >
                型号组：
                <span
                  :title="item.modelGroupsStr"
                  v-if="item.modelGroups.length"
                  ><span v-for="(item, index) in item.modelGroups" :key="index"
                    >{{ item.name }}&nbsp;&nbsp;</span
                  ></span
                >
                <span v-if="!item.modelGroups.length">暂无</span>
              </p>
              <!-- <p
                style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
              >
                语言组：
                <span :title="item.langGroupsStr" v-if="item.langGroups.length"
                  ><span v-for="(item, index) in item.langGroups" :key="index"
                    >{{ item.name }}&nbsp;&nbsp;</span
                  ></span
                >
                <span v-if="!item.langGroups.length">暂无</span>
              </p> -->
            </div>
            <div class="writeTemplate-btn">
              <span class="edit-btn" @click="edit(item)">编辑</span>
              <span class="del-btn" @click="remove(item)">删除</span>
            </div>
          </div>
        </div>
      </div>
      <pagination
        :pageSize="listParams.limit"
        :total="count"
        @pageNum="getPageNum"
      />
    </el-card>
    <transition name="fade">
      <DelPopup @deleteHandle="deleteHandle" v-if="delPopup" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pagination from '@/components/pagination'
import DelPopup from '@/components/delPopup'
export default {
  components: {
    pagination,
    DelPopup
  },
  computed: {
    ...mapGetters(['delPopup'])
  },
  data() {
    return {
      writeTemplate: [],
      writeTemplateItem: null,
      count: 0,
      listParams: {
        type: 'cloud',
        page: 1,
        limit: 20
      },
      currentEffect: 'cloud'
    }
  },
  methods: {
    async selectTag(item) {
      if (item === 'cloud') {
        this.listParams.apiVersion = 'v1'
        delete this.listParams.usage
      } else {
        this.listParams.usage = item
        this.listParams.apiVersion = 'v2'
      }
      this.currentEffect = item
      this.getWriteTemplates()
    },

    getWriteTemplates() {
      this.$http.getWriteTemplates(this.listParams).then((res) => {
        this.writeTemplate = res.data.results
        this.writeTemplate.map((item) => {
          item['modelGroupsStr'] = ''
          item.modelGroups.map((subItem) => {
            if (subItem.name) {
              item['modelGroupsStr'] += subItem.name
            }
          })
        })
        this.count = res.data.count
      })
    },

    edit(item) {
      this.writeTemplateItem = item
      this.$router.push({
        name: 'writeTemplateCreate',
        query: { id: item._id, usage: this.listParams.usage }
      })
    },

    remove(item) {
      this.writeTemplateItem = item
      this.$store.commit('windowHandle', 'delPopup')
    },
    deleteHandle() {
      this.$http.delWriteTemplates(this.writeTemplateItem._id).then((res) => {
        this.getWriteTemplates()
      })
    },
    getPageNum(page) {
      this.listParams.page = page
      this.getWriteTemplates()
    }
  },
  mounted() {
    this.listParams.apiVersion = this.currentEffect === 'cloud' ? 'v1' : 'v2'
    this.getWriteTemplates()
  }
}
</script>

<style lang="scss" scoped>
.active-button-style {
  color: #fff;
  border-color: $globalBGColor;
  background: $globalBGColor;
  > .el-icon-close {
    font-size: 15px;
  }
  > .el-tag__close {
    color: #fff;
    /* &:hover {
                            background:$globalFontSizeColor;
                        } */
  }
}
.writeTemplate-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > .el-tag {
      cursor: pointer;
    }
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
  .list-container {
    flex: 1;
    display: flex;
    overflow: hidden;
    .writeTemplate-handle {
      flex: 1;
      padding-right: 5px !important;
      flex-direction: column;
      .writeTemplate-item {
        margin: 10px;
        background: #f7f7f7;
        overflow: hidden;
        width: calc(25% - 22px);
        float: left;
        border: 1px solid #ddd;
        .writeTemplate-cover {
          height: 300px;
          background-color: #fff;
          .writeTemplate-img {
            height: 300px;
            display: block;
            margin: 0 auto;
          }
        }
        .writeTemplate-info {
          margin: 0 8px;
          overflow: hidden;
          > .writeTemplate-info-title {
            font-weight: bold;
            font-size: 14px;
            margin-top: 15px;
          }
          .writeTemplate-info-group {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          > p {
            word-wrap: break-word;
            margin: 5px 0;
          }
          .grey {
            color: #fff;
            background-color: #828282;
            padding: 4px 8px;
            font-size: 14px;
            border-radius: 2px;
          }
          .green {
            color: #fff;
            background-color: #3a983a;
            padding: 4px 8px;
            font-size: 14px;
            border-radius: 2px;
          }
        }
        .writeTemplate-btn {
          margin-top: 15px;
          margin-bottom: 10px;
          > .writeTemplate-el-icon {
            cursor: pointer;
            margin-left: 15px;
            font-size: 20px;
            padding: 2px;
            &:hover {
              background-color: #b5b5b5;
            }
            &.on-publish {
              color: #41b883;
            }
            &.off-publish {
              color: #d83a00;
            }
            &.disable-publish {
              color: #565656;
              cursor: not-allowed;
              &:hover {
                background-color: #dadada;
              }
            }
            &.writeTemplate-del {
              color: #d83a00;
            }
          }
          > span {
            color: #fff;
            padding: 4px 12px;
            border-radius: 3px;
            margin: 0 5px;
            cursor: pointer;
            display: inline-block;
            &.edit-btn {
              background-color: #337ab7;
              &:hover {
                background-color: #3783c4;
              }
            }
            &.del-btn {
              background-color: #d9534f;
              &:hover {
                background-color: #ef6f6c;
              }
            }
          }
        }
      }
    }
  }
}
</style>
